import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationViewModel, PageViewModel } from 'src/app/_models/generatedModels';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OrganizationCMSService, OrganizationService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';

@Component({
  selector: 'bxl-organization-page',
  templateUrl: 'organization-page.component.html',
})
export class OrganizationPageComponent implements OnInit {
  initialized = false;
  pageId: any;
  page: PageViewModel;
  organization: OrganizationViewModel;
  found: boolean;
  constructor(public auth: AuthenticationService, public title: AnalyticsService, public settings: SettingsProvider, private route: ActivatedRoute, private router: Router, public nav: NavigationService, public cmsService: OrganizationCMSService, public orgService: OrganizationService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.pageId = param.get('page');
      let slug = param.get('organizationId');

      this.orgService.getOrganization(slug).subscribe((organization) => {
        this.organization = organization;
        console.log(this.organization.id);
        console.log(slug);

        this.cmsService.getOrganizationPage(this.organization.id.toString(), this.pageId).subscribe(
          (page) => {
            this.page = page;
            this.title.setTitleAndLogPageView(this.page.navText + ' - ' + this.organization.name);
            this.initialized = true;
            this.found = true;
          },
          (error) => {
            this.initialized = true;
            this.found = false;
          }
        );
      });
    });
  }
}
